// Âge et barème — le tarif dépend de la PERSONNE, jamais du cours.
//
// Règle tranchée par l'école : moins de 18 ans → barème enfants & ados ;
// 18 ans et plus → barème adultes. Deux signaux, et deux seulement :
//   1. la case « Je m'inscris pour moi-même (adulte) » du formulaire ;
//   2. sinon, la date de naissance saisie dans le formulaire.
// Aucune colonne du planning (Âge min, Âge max, Âge affiché, libellés) n'entre en jeu.

import { SAISON } from "./dates";

export const AGE_ADULTE = 18;
// Plancher à 1 an, pas à 3 : Baby ballet (2-4 ans) et Danse parents-enfants (2-5 ans)
// accueillent des enfants de 2 ans, et un blocage muet ferait fuir précisément les
// familles qui n'appellent pas. Un plancher à 1 an attrape quand même la faute de frappe
// qui compte (2026 tapé au lieu de 2016 → 0 an). Pour tout ce qui est « jeune mais
// possible », c'est l'avertissement orange qui parle, pas un blocage.
export const AGE_MIN_PLAUSIBLE = 1;
export const AGE_MAX_PLAUSIBLE = 100;

// Âge révolu à une date de référence. `null` si la date est absente ou illisible.
export function ageAt(birthIso, refIso = SAISON.tarif_age_reference.iso) {
  if (!birthIso) return null;
  const b = new Date(`${String(birthIso).slice(0, 10)}T00:00:00`);
  const ref = new Date(`${String(refIso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(b.getTime()) || Number.isNaN(ref.getTime())) return null;
  let age = ref.getFullYear() - b.getFullYear();
  const m = ref.getMonth() - b.getMonth();
  if (m < 0 || (m === 0 && ref.getDate() < b.getDate())) age -= 1;
  return age;
}

// L'âge est figé au début du semestre : sinon un élève né le 20.09 paierait le tarif
// enfant en s'inscrivant le 15 septembre et le tarif adulte le 25, pour le même cours
// et le même semestre.
export function isAdultForTarifs(child, isAdultSelf = false) {
  if (isAdultSelf) return true;
  const age = ageAt(child?.birth_date);
  return age !== null && age >= AGE_ADULTE;
}

// Contrôle de plausibilité — la date de naissance fixe désormais le prix.
// Retourne un message d'erreur (bloquant) ou null.
export function birthDateError(birthIso) {
  if (!birthIso) return null; // le champ « requis » est géré ailleurs
  const b = new Date(`${String(birthIso).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(b.getTime())) return "Date de naissance illisible.";
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  if (b > today) return "Cette date est dans le futur.";
  const age = ageAt(birthIso);
  if (age === null) return "Date de naissance illisible.";
  if (age < AGE_MIN_PLAUSIBLE) {
    return `${age} an à la rentrée : vérifie l'année de naissance.`;
  }
  if (age > AGE_MAX_PLAUSIBLE) return "Vérifie l'année de naissance.";
  return null;
}

// Avertissement NON bloquant : l'élève est plus jeune que l'âge minimum du cours.
// L'école tient à sa souplesse et accepte ces cas en connaissance de cause.
export function ageWarningForCourse(child, course) {
  const age = ageAt(child?.birth_date);
  const min = course?.age_min;
  if (age === null || !min || age >= min) return null;
  return `${child.first_name || "L'élève"} aura ${age} ans à la rentrée ; ce cours est annoncé dès ${min} ans. L'école validera avec toi.`;
}
